import React, { createContext, useState } from "react";

export const NavigationContext = createContext({
    openSection: null,
    setOpenSection: () => {}
});

export const NavigationProvider = ({ children }) => {
    const [openSection, setOpenSection] = useState(null);
    const [openHoverSection, setOpenHoverSection] = useState(null);
    return (
        <NavigationContext.Provider value={{ openSection, setOpenSection, openHoverSection, setOpenHoverSection }}>
            {children}
        </NavigationContext.Provider>
    );
};
